<template>
  <b-modal
    v-model="modalVisible"
    centered
    title="Delete Export"
    ok-title="Delete"
    ok-variant="danger"
    :ok-disabled="deleteInFlight || !deleteCandidate"
    @ok="handleConfirm"
    @hidden="handleHidden"
  >
    <p class="mb-1">
      Are you sure you want to delete this export record? You cannot undo this action.
    </p>
    <p class="mb-0"><strong>Requested At:</strong> {{ deleteDetails.requestedAt }}</p>
    <p class="mb-0"><strong>Data Source:</strong> {{ deleteDetails.targetIndex }}</p>
    <p class="mb-0"><strong>Start:</strong> {{ deleteDetails.startAt }}</p>
    <p class="mb-0"><strong>End:</strong> {{ deleteDetails.endAt }}</p>
    <p class="mb-0"><strong>Records:</strong> {{ deleteDetails.numRecords }}</p>
    <p class="mb-0"><strong>Bytes:</strong> {{ deleteDetails.numBytes }}</p>
  </b-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    deleteCandidate: {
      type: Object,
      default: null,
    },
    deleteInFlight: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modalVisible: {
      get() {
        return this.visible;
      },
      set(nextVisible) {
        this.$emit('update:visible', nextVisible);
      },
    },
    deleteDetails() {
      if (!this.deleteCandidate) {
        return {
          requestedAt: '-',
          targetIndex: '-',
          startAt: '-',
          endAt: '-',
          numRecords: '-',
          numBytes: '-',
        };
      }
      return {
        requestedAt: this.deleteCandidate.requestedAt || '-',
        targetIndex: this.deleteCandidate.targetIndex || '-',
        startAt: this.deleteCandidate.startAt || '-',
        endAt: this.deleteCandidate.endAt || '-',
        numRecords: this.deleteCandidate.numRecords || '-',
        numBytes: this.deleteCandidate.numBytes || '-',
      };
    },
  },
  methods: {
    handleConfirm(event) {
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }
      this.$emit('confirm');
    },
    handleHidden() {
      this.$emit('hidden');
    },
  },
};
</script>
